import { z } from 'zod'
import { ClientAgentReferenceSchema } from '@/agent/references/store/schemas'
import { UserFilesRAGRequestSchema } from '@/agent/chat_form/store/schemas'

export const InlineEditPayloadSchema = z.object({
  artifact_version_id: z.string().uuid(),
  edit_instruction: z.string().min(1),
  anchor_start: z.string().min(1),
  anchor_end: z.string().min(1),
  caselaw_search_filter: z.unknown().optional(),
  lrr_search_filter: z.unknown().optional(),
  user_files_rag: UserFilesRAGRequestSchema.nullish().default(null),
  file_paths: z.array(z.string()).default([]),
})
export type InlineEditPayload = z.infer<typeof InlineEditPayloadSchema>

export const InlineEditResponseSchema = z.object({
  content: z.string(),
  references: z.array(ClientAgentReferenceSchema).default([]),
})
export type InlineEditResponse = z.infer<typeof InlineEditResponseSchema>
